<template>
    <div class="toggle-switch flex items-center">
        <label class="switch">
            <div class="slider round" />
        </label>
    </div>
</template>
<style scoped>
.switch {
    @apply relative inline-block;
    width: 60px;
    height: 34px;
}

.slider {
    @apply bg-secondary-dark absolute cursor-pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    @apply absolute bg-white;
    -webkit-transform: translateX(0px);
    -ms-transform: translateX(0px);
    transform: translateX(0px);
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    -webkit-transition: .4s;
    transition: .4s;
}

.active .switch .slider {
    @apply bg-primary;
}

.active .switch .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>